import { MessageTypeEnumValue } from 'enums/MessageTypeEnum';
import { useDispatch } from 'react-redux';
import { SHOW_MESSAGE } from 'redux/Message/MessageType';

export default function useToast() {
  const dispatch = useDispatch();
  return {
    saveMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'saved_successfully' },
      });
      return false;
    },
    uniqueSaveMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'saved_successfully', preventDuplicate: true },
      });
      return false;
    },
    deleteMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'deleted_successfully' },
      });
      return false;
    },
    errorMessage: error => {
      if (error?.response?.status === 400) {
        let message = '';
        if (error.response.data === 'PromotionQuantityExceeded') {
          message = 'promotionQuantityExceeded';
        } else {
          message = error.response.data;
        }
        dispatch({
          type: SHOW_MESSAGE,
          payload: { type: MessageTypeEnumValue.Danger, messageKey: message || 'data_not_available' },
        });
      } else if (error?.response?.status === 401) {
        dispatch({
          type: SHOW_MESSAGE,
          payload: { type: MessageTypeEnumValue.Danger, messageKey: error.response.data || 'data_access_denied' },
        });
      } else if (error?.response?.status === 409) {
        dispatch({
          type: SHOW_MESSAGE,
          payload: { type: MessageTypeEnumValue.Danger, messageKey: error.response.data || 'data_current_state_wrong' },
        });
      } else {
        dispatch({
          type: SHOW_MESSAGE,
          payload: { type: MessageTypeEnumValue.Danger, messageKey: error.message },
        });
      }

      return false;
    },
    offlineMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Danger, messageKey: 'now_offline' },
      });
      return false;
    },
    onlineMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'now_online' },
      });
      return false;
    },
  };
}
